"use client";

import React from "react";
import { useParams } from "next/navigation";

import { TxListContainer } from "@/components/Protocol/Activity/TableContainer";
import { classNames } from "@/utils";

export default function ProtocolActivityPage() {
  const params = useParams();

  return (
    <section className={classNames("flex flex-1 flex-col items-center justify-center pt-6")}>
      <TxListContainer slug={params.slug as string} />
    </section>
  );
}
